import { researchRoles as actionTypes } from "store/constants";
import { fetchableInitialState, reduceIsFetching, reduceSetError } from "store/factories/fetchable";
import { baseInitialState } from "store/factories/initialState";


const initialState = {
	...fetchableInitialState,
	content: {
		...baseInitialState.content,
		source: [],
		changed: [],
		isChanged: false,
	},
};

export function researchRoles (state = initialState, action) {
	switch (action.type) {
	case actionTypes.RESEARCH_ROLES_IS_FETCHING: {
		return reduceIsFetching(state, action);
	}
	case actionTypes.RESEARCH_ROLES_SET_ERROR: {
		return reduceSetError(state, action);
	}
	case actionTypes.RESEARCH_ROLES_SET_DATA:
		return {
			...state,
			content: {
				...state.content,
				source: action.payload.items,
				changed: action.payload.items,
				totalItems: action.payload.totalItems,
			},
		};
	case actionTypes.RESEARCH_ROLES_SET_CHANGED_DATA:
		return {
			...state,
			content: {
				...state.content,
				changed: action.payload.changed,
			},
		};
	case actionTypes.RESEARCH_ROLES_SET_WAS_CHANGED: {
		return {
			...state,
			content: {
				...state.content,
				isChanged: action.payload,
			},
		};
	}
	default:
		return state;
	}
}


